import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BillingUnitListComponent } from './billing-unit-list/billing-unit-list.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { BillingUnitViewComponent } from './billing-unit-view/billing-unit-view.component';
import { BillingUnitEditComponent } from './billing-unit-edit/billing-unit-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        MatRadioModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        SelectSearchModule,
        FiToggleSwitchModule,
    ],
    declarations: [BillingUnitListComponent, BillingUnitViewComponent, BillingUnitEditComponent],
})
export class BillingUnitModule {}
